import {notify} from "reapop";
import i18n from "../../i18n";
import {invokeApig} from "../../libs/awsLib";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import Paths from "../paths";

/*
 * Zapisane konfiguracje widoku tabeli (settings-api). `tableID` to stała frontu (src/constans/tableIDs.js),
 * `Config` to dowolny obiekt JSON (<= 100 KB), który backend tylko przechowuje.
 * Lista zawiera moje konfiguracje i udostępnione przez innych userów klienta (IsOwner: false).
 */

export function listTableConfigs(tableID) {
    return invokeApig(Paths.tableConfigs({tableID}));
}

export function createTableConfig(tableID, {Name, Config, Shared = false}) {
    return invokeApig({
        ...Paths.tableConfigs({tableID, method: "POST"}),
        body: {Name, Config, Shared},
    });
}

// min. jedno pole; Config zastępuje cały zapisany obiekt (bez merge)
export function updateTableConfig(tableID, configID, body) {
    return invokeApig({
        ...Paths.tableConfigs({tableID, configID, method: "PUT"}),
        body,
    });
}

export function removeTableConfig(tableID, configID) {
    return invokeApig(
        Paths.tableConfigs({tableID, configID, method: "DELETE"})
    );
}

export function tableConfigNotification(
    messageKey,
    status,
    {uniqueId = myID()} = {}
) {
    store.dispatch(
        notify({
            id: uniqueId,
            title: i18n.t("resultsDetailsTutorial.tableViewHeader"),
            message: i18n.t(messageKey),
            status,
            dismissible: true,
            dismissAfter: status === "error" ? 15000 : 5000,
        })
    );
}
